export const DELETE_PERSON_PHONE_NUMBER = "DELETE_PERSON_PHONE_NUMBER";
export const FETCH_PERSON_PHONE_NUMBER_LIST = "fetchPersonPhoneNumber";
export const SAVE_EDITED_PERSON_PHONE_NUMBER = "saveEditedPersonPhoneNumber";
export const SAVE_NEW_PERSON_PHONE_NUMBER = "saveNewPersonPhoneNumber";
export const SAVE_PERSON_PHONE_NUMBER = "savePersonPhoneNumber";
export const UPDATE_PERSON_PHONE_NUMBER = "updatePersonPhoneNumber";
